<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        @if (!loading) {
            <div class="col-md-12">
                {{ isEditMode ? "Edit" : "Create" }} User{{ isEditMode ? ` - ${user.UserName}` : "" }}
            </div>
        }
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">User Details</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <nz-tabs nzType="card">
                        <nz-tab nzTitle="General">
                            <div class="panel-body">
                                <div class="form-group">
                                    <label for="userName" class="col-md-2 control-label">
                                        Username
                                        @if (!isEditMode) {
                                            <span style="color: red">*</span>
                                        }
                                    </label>
                                    <div class="col-md-4">
                                        @if (isEditMode) {
                                            <input
                                                id="userName"
                                                name="userName"
                                                class="form-control"
                                                type="text"
                                                [value]="user.UserName"
                                                readonly
                                                disabled />
                                        } @else {
                                            <input
                                                id="userName"
                                                name="userName"
                                                type="text"
                                                required
                                                maxlength="50"
                                                #userNameMdl="ngModel"
                                                class="form-control"
                                                [(ngModel)]="user.UserName" />
                                            @if (userNameMdl.touched && userNameMdl.invalid) {
                                                <span class="text-danger"> Username is required </span>
                                            }
                                        }
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="email" class="col-md-2 control-label">
                                        Email
                                        @if (!isEditMode) {
                                            <span style="color: red">*</span>
                                        }
                                    </label>
                                    <div class="col-md-4">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            required
                                            maxlength="255"
                                            #emailMdl="ngModel"
                                            class="form-control"
                                            [(ngModel)]="user.Email" />
                                        @if (emailMdl.touched && emailMdl.invalid) {
                                            <span class="text-danger"> Email is required </span>
                                        }
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password" class="col-md-2 control-label">
                                        Password
                                        @if (!isEditMode) {
                                            <span style="color: red">*</span>
                                        }
                                    </label>
                                    <div class="col-md-4">
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            [required]="!isEditMode"
                                            #passwordMdl="ngModel"
                                            class="form-control"
                                            [(ngModel)]="user.UserPassword" />
                                        @if (!isEditMode && passwordMdl.touched && passwordMdl.invalid) {
                                            <span class="text-danger"> Password is required </span>
                                        }
                                    </div>
                                </div>
                                @if (isEditMode) {
                                    <div class="form-group">
                                        <label for="password-confirm" class="col-md-2 control-label">
                                            Confirm Password
                                            @if (isEditMode && user.UserPassword?.length > 0) {
                                                <span style="color: red">*</span>
                                            }
                                        </label>
                                        <div class="col-md-4">
                                            <input
                                                id="password-confirm"
                                                name="password-confirm"
                                                type="password"
                                                [required]="isEditMode && user.UserPassword?.length > 0"
                                                #passwordConfirmMdl="ngModel"
                                                class="form-control"
                                                [(ngModel)]="passwordConfirm" />
                                            @if (
                                                isEditMode &&
                                                user.UserPassword?.length > 0 &&
                                                passwordConfirmMdl.touched &&
                                                passwordConfirmMdl.invalid
                                            ) {
                                                <span class="text-danger"> Please confirm password </span>
                                            }
                                        </div>
                                    </div>
                                }
                                <div class="form-group">
                                    <div class="col-md-2 control-label">Roles</div>
                                    <div class="col-md-4 roles-div">
                                        <div>
                                            <div>
                                                <nz-switch
                                                    name="performaAdmin"
                                                    id="performaAdmin"
                                                    nzSize="small"
                                                    [(ngModel)]="user.Permissions.PerFormaAdmin"
                                                    [nzCheckedChildren]="checkedTmpl"
                                                    [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                PerForma Admin
                                            </div>
                                        </div>
                                        @if (moduleIsEnabled("Scan")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="performaScanAdmin"
                                                        id="performaScanAdmin"
                                                        nzSize="small"
                                                        [(ngModel)]="user.Permissions.PerFormaScanAdmin"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    PerForma Scan Admin
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("ARReport")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="arreportUser"
                                                        id="arreportUser"
                                                        nzSize="small"
                                                        [(ngModel)]="user.Permissions.ARReportUser"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    AR Report User
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("FINReport")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="finreportUser"
                                                        id="finreportUser"
                                                        nzSize="small"
                                                        [(ngModel)]="user.Permissions.FINReportUser"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    FIN Report User
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("APCheck")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="apCheckEnabled"
                                                        id="apCheckEnabled"
                                                        nzSize="small"
                                                        [(ngModel)]="apCheckEnabled"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"
                                                        (ngModelChange)="onApCheckEnabledChange($event)"></nz-switch>
                                                    AP-Check
                                                </div>
                                                @if (apCheckEnabled) {
                                                    <div style="margin: 5px 0px 5px 10px">
                                                        <nz-radio-group
                                                            name="apCheckRole"
                                                            nzButtonStyle="solid"
                                                            nzSize="small"
                                                            [(ngModel)]="apCheckRole"
                                                            (ngModelChange)="onApCheckRoleChange($event)">
                                                            <label nz-radio-button nzValue="User">User</label>
                                                            <label nz-radio-button nzValue="Admin">Admin</label>
                                                        </nz-radio-group>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab nzTitle="Two-Factor">
                            <div class="panel-body">
                                @if (this.user.UserName.toLowerCase() === myUsername.toLowerCase()) {
                                    <div>
                                        Please go <a [routerLink]="['/profile/two-factor']">here</a> to manage your
                                        two-factor authentication
                                    </div>
                                } @else {
                                    @if (user.TwoFactorEnabled) {
                                        <div>
                                            <div>
                                                This account is currently enrolled in Two-Factor Authentication
                                                <span style="color: green" class="fa-solid fa-check"></span>
                                            </div>
                                            <div style="padding-top: 10px">
                                                <button
                                                    [nz-tooltip]="(force2fa ? 'Reset' : 'Disable') + ' 2FA'"
                                                    class="btn btn-danger"
                                                    (click)="resetUser2FA()">
                                                    {{ force2fa ? "Reset" : "Disable" }} 2FA
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    @if (!user.TwoFactorEnabled) {
                                        <div>
                                            <div>
                                                This account is
                                                <span style="text-decoration: underline">not</span> enrolled in
                                                Two-Factor Authentication
                                                <span style="color: red" class="fa-solid fa-x"></span>
                                            </div>
                                            @if (force2fa) {
                                                <div>
                                                    <div>&nbsp;</div>
                                                    <div>They will be prompted to set up 2FA during the login.</div>
                                                </div>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        </nz-tab>
                        <nz-tab nzTitle="Groups" [nzDisabled]="user.Groups?.length === 0">
                            <div class="panel-body">
                                <nz-table
                                    #groupTable
                                    [nzData]="userGroups"
                                    nzTableLayout="fixed"
                                    emptyText="No groups assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of groupColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of groupTable.data; track data.GroupID) {
                                            <tr>
                                                <td>
                                                    {{ data.GroupName }}
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.GroupName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeGroup(data.GroupID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        name="groupSelect"
                                        id="groupSelect"
                                        nzShowSearch
                                        nzAllowClear
                                        nzSelectOnTab
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableGroups"
                                        [(ngModel)]="selectedGroup"
                                        nzPlaceHolder="Assign group"></nz-select>
                                    <button
                                        nz-tooltip="Assign Group"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignGroup(selectedGroup)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        @if (isEditMode) {
                            <nz-tab nzTitle="Document Type Privileges">
                                <div class="panel-body">
                                    <nz-table
                                        #privTable
                                        [nzData]="userDocTypes"
                                        nzShowSizeChanger
                                        nzTableLayout="fixed"
                                        nzShowPagination="false"
                                        emptyText="No document type privileges assigned"
                                        nzBordered="true"
                                        [nzLoading]="loading">
                                        <thead style="border: 1px solid black">
                                            <tr>
                                                @for (column of columns; track column) {
                                                    <th>{{ column.title }}</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (data of privTable.data; track data.DocumentTypeID) {
                                                <tr>
                                                    <td>{{ data.DocumentTypeName }}</td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'upload_' + data.DocumentTypeID"
                                                            [name]="'upload_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.UploadFile"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'editKeyword_' + data.DocumentTypeID"
                                                            [name]="'editKeyword_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.EditKeywordData"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'addNotes_' + data.DocumentTypeID"
                                                            [name]="'addNotes_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.AddNotes"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'deleteDocs_' + data.DocumentTypeID"
                                                            [name]="'deleteDocs_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.DeleteDocuments"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'scanAdmin_' + data.DocumentTypeID"
                                                            [name]="'scanAdmin_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.PerFormaScan"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <nz-switch
                                                            [id]="'deleteScan_' + data.DocumentTypeID"
                                                            [name]="'deleteScan_' + data.DocumentTypeID"
                                                            nzSize="small"
                                                            [(ngModel)]="data.DocumentPermissions.DeleteScan"
                                                            [nzCheckedChildren]="checkedTmpl"
                                                            [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    </td>
                                                    <td style="text-align: center">
                                                        <button
                                                            nz-tooltip="Remove {{ data.DocumentTypeName }}"
                                                            nz-button
                                                            class="btn btn-default"
                                                            (click)="removeDocType(data.DocumentTypeID)">
                                                            <span class="fa-solid fa-trash"></span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </nz-table>
                                    <div
                                        style="
                                            display: flex;
                                            width: 50%;
                                            align-items: center;
                                            gap: 8px;
                                            margin-top: 8px;
                                        ">
                                        <nz-select
                                            id="docTypeSelect"
                                            name="docTypeSelect"
                                            nzShowSearch
                                            nzAllowClear
                                            nzSelectOnTab
                                            style="width: 100%"
                                            [nzShowArrow]="false"
                                            [nzOptions]="selectableDocTypes"
                                            [(ngModel)]="selectedDocType"
                                            nzPlaceHolder="Add Document Type"></nz-select>
                                        <button
                                            nz-tooltip="Add Document Type"
                                            nz-button
                                            class="btn btn-default"
                                            (click)="addDocType(selectedDocType)">
                                            <span style="color: green" class="fa-solid fa-plus"></span>
                                        </button>
                                    </div>
                                </div>
                            </nz-tab>
                        }
                    </nz-tabs>
                </form>
            </div>
        </div>
        <button class="btn btn-default" (click)="save(frm)">Save Details</button>
        @if (isEditMode) {
            <button
                class="btn btn-default"
                (click)="reset()"
                nz-tooltip="Undo all changes since the last successful save">
                Reset
            </button>
        }
        <button class="btn btn-default" (click)="goBack()">
            {{ isEditMode ? "Back To Users" : "Cancel" }}
        </button>
        @if (user.UserID) {
            <button class="btn btn-danger pull-right" (click)="remove()">Delete User</button>
        }
    </div>
</div>
<ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
<ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
